import { useLocation, Navigate } from 'react-router-dom';
import { useAppSelector } from '../hooks/hooks';
import WithLoader from '../components/Spinner/WithLoader';

interface propAuth {
  children: JSX.Element;
}

export const RequireAuth = ({ children }: propAuth) => {
  const { isLogin, isLoading } = useAppSelector((state) => state.user);
  const location = useLocation();
  // if (isLoading) return <WithLoader />;
  if (!isLogin) {
    return <Navigate to="/portal_app" state={{ from: location }} replace />;
  }
  return <WithLoader loading={isLoading}>{children}</WithLoader>;
};
